import { ComponentType, ReactNode, useRef } from 'react';

import classNames from 'classnames';

import Download from '@uikit/icons/Download';
import FilledHeart from '@uikit/icons/FilledHeart';

interface AppDetailsInteractionStatsProps {
  likes: number;
  downloads: number | null;
  className?: string;
}

const getDownloadsLabel = (downloads: number) =>
  `${downloads} Follower${downloads !== 1 ? 's' : ''}`;
const getLikesLabel = (likes: number) => `${likes} Like${likes !== 1 ? 's' : ''}`;

const AppDetailsInteractionStats = ({
  likes,
  className,
  downloads,
}: AppDetailsInteractionStatsProps) => {
  const initialDownloadsLabel = useRef(getDownloadsLabel(downloads || 0)).current;
  const initialLikesLabel = useRef(getLikesLabel(likes || 0)).current;
  const stats: {
    Icon: ComponentType;
    content: ReactNode;
    hidden?: boolean;
    iconClassName?: string;
  }[] = [
    {
      Icon: Download,
      content: (
        <span className="relative inline-block text-right">
          <span className="invisible pl-3">{initialDownloadsLabel}</span>
          <span className="inline-block absolute right-0" data-qa="info-stats-followers">
            {getDownloadsLabel(downloads || 0)}
          </span>
        </span>
      ),
      hidden: downloads === null,
    },
    {
      Icon: FilledHeart,
      content: (
        <span className="relative inline-block text-right">
          <span className="invisible pl-3">{initialLikesLabel}</span>
          <span className="inline-block absolute right-0" data-qa="info-stats-likes">
            {getLikesLabel(likes)}
          </span>
        </span>
      ),
    },
  ];

  return (
    <ul className={classNames('flex flex-wrap gap-4 t-body2', className)}>
      {stats.map(({ hidden, content, Icon }, i) => {
        if (hidden) {
          return null;
        }

        return (
          <li key={i} className="flex items-center whitespace-nowrap">
            <span className="icon-xs transition-colors text-neutral-500">
              <Icon />
            </span>
            {content}
          </li>
        );
      })}
    </ul>
  );
};

export default AppDetailsInteractionStats;
